<template>
  <div>
    <v-combobox
      class="combobox mx-4"
      :v-model="value"
      :items="items"
      :label="searchText"
      :search-input.sync="search"
      clearable
      color="white"
      dense
      item-text="description"
      item-value="code"
      prepend-inner-icon="search"
      solo
      @keyup.enter="showProductsValue()"
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>Busca tu producto</v-list-item-title>
        </v-list-item>
      </template>

      <template v-slot:item="data">
        <template v-if="typeof data !== 'object'">
          <v-list-item-content v-text="data.item"></v-list-item-content>
        </template>

        <template v-else>
          <v-list-item-content>
            <v-list-item-title v-html="data.item.description">
            </v-list-item-title>

            <v-list-item-subtitle
              v-html="'<strong>Keywords</strong> ' + data.item.keywords"
            >
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-combobox>
  </div>
</template>

<script>
export default {
  name: "autocomplete",

  data() {
    return {
      value: "",
      items: [],
      search: null,
      typingTimer: "",
    };
  },

  props: {
    searchText: { type: String },
  },

  methods: {
    showProductsValue() {
      if (this.search.length > 0) {
        this.$router.push(`/products?value=${encodeURIComponent(this.search)}`);
      }
    },
  },

  watch: {
    search(val) {
      var typingInterval = 900;
      var vm = this;
      // Lazily load input items
      if (val != null) {
        if (val.length >= 3) {
          clearTimeout(vm.typingTimer);
          vm.typingTimer = setTimeout(function () {
            vm.$http
              .get("product/searchP?value=" + encodeURIComponent(val))
              .then((response) => {
                vm.items = response.body.data.products;
                vm.$forceUpdate();
              })
              .catch((err) => {
                console.log(err);
              })
              .finally(() => (vm.isLoading = false));
          }, typingInterval);
        } else {
          this.items = null;
        }
      }
    },
  },
};
</script>

<style scoped>
.v-input__slot {
  background-color: white !important;
}
.input {
  background-color: white;
}

.autocomplete {
  position: relative;
}

.autocomplete-results {
  background-color: white;
  padding: 0px;
  margin: 0px;
  border: 1px solid #eeeeee;
  height: 120px;
  overflow: auto;
}

.autocomplete-result {
  color: black;
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
}

.autocomplete-result:hover {
  background-color: #4aae9b;
  color: white;
}
</style>
